import React from "react";
import {
  Paper,
  Button,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Tooltip,
  Divider,
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, ConfirmDialog } from "../include";
import _ from "underscore";

class AccessProfileForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissionsData: this.props.permissionsData,
      id: this.props.row ? this.props.row.id : null,
      name: this.props.row ? this.props.row.name : "",
      ids: this.props.row ? this.props.row.permission_id : [],
    };
  }

  handleSubmit = () => {
    const dt = {
      name: this.state.name,
      ids: this.state.ids,
    };
    if (!this.props.edit) {
      this.props.api
        .post("/UserProfiles", dt)
        .then((r) => {
          this.props.dialogClose();
          this.props.alert(r.message);
        })
        .catch((e) => this.props.alert("Ocorreu um erro ao criar o perfil"));
    } else {
      this.props.api
        .put("/UserProfile/" + this.state.id, dt)
        .then((r) => {
          this.props.row.permission_id = this.state.ids;
          this.props.dialogClose();
          this.props.alert("Alterações salvas com sucesso");
        })
        .catch((e) => this.props.alert("Ocorreu um erro ao alterar o perfil"));
    }
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle>{this.props.edit ? "Editar perfil de acesso" : "Novo perfil de acesso"}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            variant="outlined"
            label="Nome do perfil de acesso"
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
          />
          <D h="1rem" />
          <Typography variant="h6" component="div">
            Tipos de acessos do perfil
          </Typography>
          <D className="scB" style={{ background: "#efefef", borderRadius: "5px" }}>
            {this.state.permissionsData &&
              Object.keys(this.state.permissionsData).map((p) => {
                const perm_read = _.findWhere(this.state.permissionsData[p], {
                  name: "Ler",
                });
                const perm_write = _.findWhere(this.state.permissionsData[p], {
                  name: "Escrever",
                });
                return (
                  <D key={p} className="row aF" style={{ padding: "0.5rem" }}>
                    <D e>{p}</D>
                    <FormControlLabel
                      value="Ler"
                      label="Ler"
                      labelPlacement="end"
                      control={
                        <Checkbox
                          checked={this.state.ids.indexOf(perm_read?.id) !== -1}
                          onChange={() => {
                            const permId = perm_read.id;
                            const ids = this.state.ids.includes(permId)
                              ? _.without(this.state.ids, permId)
                              : _.union(this.state.ids, [permId]);
                            this.setState({ ids });
                          }}
                        />
                      }
                      disabled={!perm_read}
                    />
                    <FormControlLabel
                      value="Escrever"
                      label="Escrever"
                      labelPlacement="end"
                      control={
                        <Checkbox
                          checked={this.state.ids.indexOf(perm_write?.id) !== -1}
                          onChange={() => {
                            const permId = perm_write.id;
                            const ids = this.state.ids.includes(permId)
                              ? _.without(this.state.ids, permId)
                              : _.union(this.state.ids, [permId]);
                            this.setState({ ids });
                          }}
                        />
                      }
                      disabled={!perm_write}
                    />
                  </D>
                );
              })}
          </D>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}

export class AccessProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: "",
      dataTable: [],
      permissionsData: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === "w"
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: "id", headerName: "ID", width: 70 },
      { field: "name", headerName: "Perfil de acesso", width: 200 },
    ];
  }

  componentDidMount() {
    this.updateData();
    this.props.api
      .get("/Permissions")
      .then((r) => this.setState({ permissionsData: _.groupBy(r.permissions, "category") }));
  }

  updateData(page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) {
    this.setState({ loading: true });
    this.props.api
      .get("/UserProfiles", { params: { page, pageSize, search: searchField } })
      .then((r) => {
        this.setState({
          dataTable: r.profiles || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.indexOf(i) > -1 ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };

  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: "5px" }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  {this.props.permission === "w" && (
                    <Tooltip title="Editar item" arrow>
                      <IconButton
                        onClick={() =>
                          this.props.dialog(
                            <AccessProfileForm
                              edit={true}
                              row={this.state.selectedRows[0]}
                              permissionsData={this.state.permissionsData}
                              api={this.props.api}
                              alert={this.props.alert}
                              dialogClose={() => {
                                this.props.dialogClose();
                                this.setState({ selectedRows: [] });
                                this.updateData();
                              }}
                            />
                          )
                        }
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  )}
                  <D size="0.5rem" />
                </>
              )}

              {this.state.selectedRows.length > 0 && (
                <>
                  {this.props.permission === "w" && (
                    <Tooltip title="Excluir selecionados" arrow>
                      <IconButton
                        onClick={() =>
                          this.props.dialog(
                            <ConfirmDialog
                              title="Excluir Itens"
                              msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                              reg={
                                this.state.selectedRows.length > 1
                                  ? this.state.selectedRows.length + " registros selecionados"
                                  : "1 registro selecionado"
                              }
                              onCancel={this.props.dialogClose}
                              onConfirm={() => {
                                for (var i in this.state.selectedRows) {
                                  var id = this.state.selectedRows[i].id;
                                  this.props.api
                                    .delete("/UserProfile/" + id)
                                    .then((r) => {
                                      this.props.alert(r.message);
                                      this.props.dialogClose();
                                      this.setState({ selectedRows: [] });
                                      this.updateData();
                                    })
                                    .catch((e) =>
                                      this.props.alert("Ocorreu um erro ao excluir o registro")
                                    );
                                }
                              }}
                            />
                          )
                        }
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  )}
                  <D size="0.5rem" />
                </>
              )}

              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: "12px" }}
                  onClick={() =>
                    this.props.dialog(
                      <AccessProfileForm
                        permissionsData={this.state.permissionsData}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: "100%", height: "800px", overflow: "hidden" }}>
          <DataGrid
            rows={dataTable || []}
            columns={this.columns || []}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                        
          />
        </Paper>
      </D>
    );
  }
}

